import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { perfil } from 'src/app/models/perfil';
import { AlertifyService } from 'src/app/services/alertify.service';
import { ProfileService } from 'src/app/services/profile.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-createedituser',
  templateUrl: './createedituser.component.html',
  styleUrls: ['./createedituser.component.scss'],
})
export class CreateedituserComponent implements OnInit {
  public documentos: any;
  public perfiles: perfil[];
  registerForm: UntypedFormGroup;
  public isForEdit = false;
  public dataInput: any;

  constructor(
    public perfilSvc: ProfileService,
    public usrSvc: UserService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreateedituserComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);
    if (data != null) {
      this.isForEdit = true;
    }
  }

  ngOnInit(): void {
    this.registerForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      nombre: new UntypedFormControl('', Validators.required),
      tipoDoc: new UntypedFormControl('', Validators.required),
      documento: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(15),
      ]),
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      celular: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('[0-9]*'),
      ]),
      telefono: new UntypedFormControl(),
      direccion: new UntypedFormControl(),
      ciudad: new UntypedFormControl(),
      perfil: new UntypedFormControl('', Validators.required),
    });

    this.documentos = [
      { value: 1, nombre: 'CC' },
      { value: 2, nombre: 'Pasaporte' },
      { value: 3, nombre: 'NIT' },
      { value: 4, nombre: 'C. Extranjeria' },
    ];

    this.perfilSvc.getPerfiles().subscribe((x) => {
      this.perfiles = x;

      if (this.dataInput != null) {
        //aqui debe ir al backend por la info del usuario y llenarla
        this.registerForm.get('id')?.setValue(this.dataInput.id); 
        this.registerForm.get('nombre')?.setValue(this.dataInput.nombre);
        this.registerForm.get('tipoDoc')?.setValue(this.dataInput.tipoDocumento);
        this.registerForm.get('documento')?.setValue(this.dataInput.documento);
        this.registerForm.get('email')?.setValue(this.dataInput.email);
        this.registerForm.get('celular')?.setValue(this.dataInput.celular);
        this.registerForm.get('telefono')?.setValue(this.dataInput.telefono); 
        this.registerForm.get('direccion')?.setValue(this.dataInput.direccion);
        this.registerForm.get('ciudad')?.setValue(this.dataInput.ciudad);        
       this.registerForm.get('perfil')?.setValue(this.dataInput.perfilId); 
      }
    });
  }

  getErrorMessageEmail() {
    if (this.registerForm.get('email')?.hasError('required')) {
      return 'El email es requerido';
    }
    if (this.registerForm.get('email')?.hasError('email')) {
      return 'No es un email valido';
    }
    return '';
  }

  guardar() {
    console.log('guardar usuario');
    console.log(this.registerForm.value);
    if(this.isForEdit){
      //aqui mando a editar
      this.usrSvc.EditarUsuarioPorLiga(this.registerForm.value).subscribe((res) => {
        console.log('resultado EditarUsuario por liga: ', res);
        if(res){
          this.alertify.success("Usuario actualizado correctamente");
          this.dialogRef.close();
        }else{
          this.alertify.error("El usuario no se ha podido actualizar");
        }
      });
    }
    else{
      //aqui mando a crearlo
      this.registerForm.get('id')?.setValue('00000000-0000-0000-0000-000000000000');       
      this.usrSvc.crearUsuario(this.registerForm.value).subscribe((res) => {
        console.log('resultado crearUsuario: ', res);
        if(res){
          this.alertify.success("Usuario creado correctamente");
          this.dialogRef.close();
        }else{
          this.alertify.error("El usuario ya existe, valide la información e intentelo de nuevo");
        }
      });
    }
  }
}
